import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './App'; // เปลี่ยนการนำเข้าจาก App เป็น AppRouter
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRouter /> {/* เรียกใช้ AppRouter แทน App */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();